import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", as = "div", ...props }) => {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...props}
    >
      {children}
    </Tag>
  );
};

export const SectionHeading = ({ label, title, accent, description, testId }) => (
  <div className="mb-14 max-w-3xl" data-testid={testId}>
    <Reveal>
      <p className="mb-4 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-electric">
        <span className="h-px w-10 bg-electric" aria-hidden="true" />
        {label}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-display text-4xl font-semibold uppercase leading-[1.05] tracking-tight text-neutral-100 sm:text-5xl">
        {title} {accent && <span className="text-electric">{accent}</span>}
      </h2>
    </Reveal>
    {description && (
      <Reveal delay={0.16}>
        <p className="mt-5 text-base leading-relaxed text-neutral-400 sm:text-lg">{description}</p>
      </Reveal>
    )}
  </div>
);
